import * as React from "react";
import { Icon, TooltipApi } from "sb-resp-ui";

export class EventIcon extends React.Component<{
    shouldRender: boolean,
    modifier: string,
    tooltip: string,
    action?: Function
}, {}> {
    clickHandler: Function;
    iconClass: string;
    rowClass: string;

    constructor(props) {
        super(props);
        this.clickHandler = typeof this.props.action !== "function" ? this.noop : this.props.action;
        this.iconClass = this.props.shouldRender ? `rj-sports-multiview__event-icons-icon ${this.props.modifier}` : "i-24-16 rj-sports-multiview__event-icons-icon-empty";
        this.rowClass = this.props.shouldRender ? "" : "rj-sports-multiview__event-icons-row-empty";
    }

    noop() { return false; }

    render() {
        return (
            <div className={`rj-sports-multiview__event-icons-row ${this.rowClass}`} onClick={(event) => { this.clickHandler(event) }}
                {...TooltipApi.getInstance().setMessage(this.props.tooltip)}>
                <Icon i={this.iconClass} />
            </div>
        )
    }
}